import { DeleteAction, EditAction } from "@/components/Action";
import { DATE_FORMAT } from "@/constants/default";
import { usePermissions } from "@/rbac";
import { permissions } from "@/rbac/permissions";
import { HouseRental } from "@/types/house-rental.type";
import { formatDateTimeAutoToString } from "@/utils/format";
import { classNameExpiredRental, showStatusRental } from "@/utils/helper";
import { ColumnDef } from "@tanstack/react-table";
import _ from "lodash";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";

export default function TableHeader(): ColumnDef<HouseRental>[] {
    const {t} = useTranslation();
    const { hasPermission } = usePermissions();
    const navigate = useNavigate()
    const location = useLocation()

    return [
        {
            header: t("house_rental.business_unit"),
            accessorKey: "business_unit_name",
            cell: ({row}) => (
                <div className="cursor-pointer" onClick={() => navigate(location , {state: {modal: "/house-rentals/property", id: row.original.business_unit_id}})}>{row.original.business_unit_name}</div>
            )
        },
        {
            header: t("house_rental.take_over"),
            accessorKey: "take_over",
            cell: ({ row }) => formatDateTimeAutoToString(row.original.take_over ?? '', "ll")
        },
        {
            header: t("house_rental.ta_start"),
            accessorKey: "ta_start",
            cell: ({ row }) => formatDateTimeAutoToString(row.original.ta_start ?? '', "ll")
        },
        {
            header: t("house_rental.ta_end"),
            accessorKey: "ta_end",
            meta: {
                className: "!px-0 !py-0 min-w-26 w-26"
            },
            cell: ({ row }) => <div className={`py-2 px-2 dark:text-white  ${classNameExpiredRental(row.original.status, row.original.ta_end)}`}>
                {formatDateTimeAutoToString(row.original.ta_end ?? '', "ll")}
            </div>
        },
        {
            header: t("house_rental.rent"),
            accessorKey: "rent",
            cell: ({row}) => {
                return row.original.rent > 0 && <span>${row.original.rent.toFixed(2)}</span>
            }
        },
        {
            header: t("house_rental.deposit_amount"),
            accessorKey: "deposit_amount",
            cell: ({row}) => {
                return row.original.deposit_amount > 0 && <span>${row.original.deposit_amount.toFixed(2)}</span>
            }
        },
        // {
        //     header: t("house_rental.rent_free"),
        //     accessorKey: "rent_free",
        //     enableSorting: false,
        //     cell: ({row}) => row.original.rent_free >= 0 ? row.original.rent_free : ""
        // },
        // {
        //     header: t("house_rental.warranty"),
        //     accessorKey: "warranty",
        //     enableSorting: false,
        //     cell: ({row}) => row.original.warranty >= 0 ? row.original.warranty : ""
        // },
        {
            header: t("house_rental.agent_name"),
            accessorKey: "agent_name",
        },
        // {
        //     header: t("table.created_at"),
        //     accessorKey: "created_at",
        //     cell: ({ row }) => formatDateTimeAutoToString(row.original.created_at ?? '', DATE_FORMAT)
        // },
        {
            header: t("table.status"),
            accessorKey: "status",
            meta: {
                className: "min-w-30 w-30"
            },
            cell: ({ row }) => <div dangerouslySetInnerHTML={{__html: showStatusRental(row.original.status, row.original.ta_start, row.original.ta_end)}} />
            // cell: ({ row }) => <div dangerouslySetInnerHTML={{__html: showDateExpired(row.original.ta_start, row.original.ta_end)}} />
        },
        {
            header: t("table.action"),
            accessorKey: "action",
            enableSorting: false,
            cell: ({ row }) => (
                <div className="flex items-center space-x-3.5">
                    {
                        hasPermission(permissions.HOUSERENTAL.EDIT) && <EditAction onClick={() => navigate(location , {state: {modal: "/house-rentals/edit", id: row.original.id}})} />
                    }
                    {
                        hasPermission(permissions.HOUSERENTAL.DELETE) && <DeleteAction onClick={() => navigate(location , {state: {modal: "/house-rentals/delete", id: row.original.id}})} />
                    }
                </div>
            )
        }
    ]
}